<div class="flex h-full gap-4">
  <div class="flex w-full flex-1 items-center justify-center">
    @if (multimedia$ | async; as multimedia) {
      @switch (true) {
        <!-- Obsługa podglądu plików graficznych -->
        @case (multimedia.details.isImage) {
          <app-multimedia-image-preview
            [alt]="multimedia.details.alt"
            [width]="multimedia.details.width!"
            [height]="multimedia.details.height!"
            [previewUrl]="multimedia.details.previewUrl" />
        }
        <!-- Obsługa podglądu dokumentów -->
        @case (multimedia.details.isDocument) {
          <app-multimedia-document-preview
            [alt]="multimedia.details.alt"
            [width]="multimedia.details.width!"
            [height]="multimedia.details.height!"
            [previewUrl]="multimedia.details.previewUrl" />
        }
        <!-- Obsługa podglądu archiwów -->
        @case (multimedia.details.isArchive) {
          <app-multimedia-archive-preview
            [alt]="multimedia.details.alt"
            [width]="multimedia.details.width!"
            [height]="multimedia.details.height!"
            [previewUrl]="multimedia.details.previewUrl" />
        }
        @default {
          <app-image-thumbnail-unsupported size="xxl" />
        }
      }
    } @else {
      <app-spinner-filled />
    }
  </div>

  <div class="w-100 overflow-y-auto bg-gray-50 p-6">
    @if (multimedia$ | async; as multimedia) {
      <app-multimedia-attributes [multimedia]="multimedia.details" />

      <p-divider />

      @if (multimedia.details.canBeEdited) {
        <app-multimedia-details-form
          [data]="multimedia.form"
          (submitClickEvent)="handleSubmitClickEvent($event)" />
      } @else {
        <app-multimedia-attributes
          [multimedia]="multimedia.details"
          [attributesToShow]="['filename', 'alt', 'description']" />
      }

      <p-divider />

      <div class="mt-4 flex justify-center">
        @if (multimedia.details.canBeRemoved) {
          <p-button
            [text]="true"
            (onClick)="handleRemoveClick()"
            size="small"
            severity="danger"
            appPrimengButton
            label="Usuń" />
        }

        <p-button
          [text]="true"
          (onClick)="handleDownloadClick(multimedia.details)"
          size="small"
          label="Pobierz plik"
          appPrimengButton />

        <p-button
          [text]="true"
          (onClick)="handleCopyLinkClick(multimedia.details)"
          size="small"
          label="Skopiuj adres URL"
          appPrimengButton />
      </div>
    } @else {
      <app-spinner-filled />
    }
  </div>
</div>
